module.exports = __webpack_public_path__ + "img/15.38ea2d44.png";